import moment from 'moment';

export const damMonitoringDefaultFilters = {
  startDate: moment().startOf('day').subtract(1, 'month').valueOf(),
  endDate: moment().endOf('day').valueOf(),
  selectedGraphView: 0
};
